import { Control, Controller } from 'react-hook-form';
import { BulkOpsFormValues } from './create-bulk-op-dialog';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';

interface StepAdditionalOptionsProps {
  control: Control<BulkOpsFormValues>;
}

export default function StepAdditonalOptions({
  control,
}: StepAdditionalOptionsProps) {
  return (
    <Stack gap={1} width={'100%'}>
      <Stack>
        <Controller
          name="createGroups"
          control={control}
          render={({ field: props }) => (
            <FormControlLabel
              control={<Checkbox {...props} />}
              label="Auto-create groups that do not exist"
            />
          )}
        />
      </Stack>
    </Stack>
  );
}
